import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";
export const FAQSection = () => {
  const isMobile = useIsMobile();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.6
  }} className="mb-8 md:mb-12 w-full">
      <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-blue-700">Usein kysytyt kysymykset</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        <Card className="w-full shadow-sm">
          <CardHeader className="pb-2 md:pb-3">
            <CardTitle className="text-base md:text-lg text-blue-700">Mitä lainan kilpailuttaminen tarkoittaa?</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-800 text-base md:text-base leading-relaxed">
              Lainan kilpailuttaminen tarkoittaa sitä, että pyydät tarjouksia useilta eri pankeilta ja 
              rahoituslaitoksilta ja vertailet niitä keskenään. Näin löydät edullisimman vaihtoehdon.
            </p>
          </CardContent>
        </Card>
        
        <Card className="w-full shadow-sm">
          <CardHeader className="pb-2 md:pb-3">
            <CardTitle className="text-base md:text-lg text-blue-700">Onko lainan kilpailuttaminen maksullista?</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-800 text-base md:text-base leading-relaxed">Ei, Lainasampo.fi:n kautta lainan kilpailuttaminen on täysin maksutonta. </p>
          </CardContent>
        </Card>
        
        <Card className="w-full shadow-sm">
          <CardHeader className="pb-2 md:pb-3">
            <CardTitle className="text-base md:text-lg text-blue-700">Kuinka nopeasti saan lainatarjoukset?</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-800 text-base md:text-base leading-relaxed">
              Yleensä saat ensimmäiset lainatarjoukset jo saman päivän aikana. Kaikkien tarjousten 
              saaminen voi kestää 1-3 arkipäivää riippuen pankkien käsittelyajoista.
            </p>
          </CardContent>
        </Card>
        
        <Card className="w-full shadow-sm">
          <CardHeader className="pb-2 md:pb-3">
            <CardTitle className="text-base md:text-lg text-blue-700">Vaikuttaako kilpailuttaminen luottotietoihini?</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-800 text-base md:text-base leading-relaxed">
              Ei, pelkkä lainatarjousten pyytäminen Lainasampo.fi:n kautta ei vaikuta luottotietoihisi. 
              Luottotietoja tarkistetaan vasta, kun hyväksyt jonkin tarjouksen.
            </p>
          </CardContent>
        </Card>
      </div>
    </motion.div>;
};